import Decimal from 'decimal.js-light'
import pako from 'pako'
import CryptoJS from 'crypto-js'
import cookie from 'js-cookie'
import { useStorage } from '@vueuse/core'
import { defaultDialingCode, dialingLocaleMap } from './locale'
// eslint-disable-next-line vars-on-top,no-var,block-scoped-var,style/max-statements-per-line
export const md5 = (function () { for (var m = [], l = 0; l < 64;)m[l] = 0 | 4294967296 * Math.abs(Math.sin(++l)); return function (c) { let e; let g; let f; let a; const h = []; c = unescape(encodeURI(c)); for (var b = c.length, k = [e = 1732584193, g = -271733879, ~e, ~g], d = 0; d <= b;)h[d >> 2] |= (c.charCodeAt(d) || 128) << 8 * (d++ % 4); h[c = 16 * (b + 8 >> 6) + 14] = 8 * b; for (d = 0; d < c; d += 16) { b = k; for (a = 0; a < 64;)b = [f = b[3], (e = b[1] | 0) + ((f = b[0] + [e & (g = b[2]) | ~e & f, f & e | ~f & g, e ^ g ^ f, g ^ (e | ~f)][b = a >> 4] + (m[a] + (h[[a, 5 * a + 1, 3 * a + 5, 7 * a][b] % 16 + d] | 0))) << (b = [7, 12, 17, 22, 5, 9, 14, 20, 4, 11, 16, 23, 6, 10, 15, 21][4 * b + a++ % 4]) | f >>> 32 - b), e, g]; for (a = 4; a;)k[--a] = k[a] + b[a] } for (c = ''; a < 32;)c += (k[a >> 3] >> 4 * (1 ^ a++ & 7) & 15).toString(16); return c } }())

export function addZero(t) {
  return t > 9 ? t : `0${+t}`
}
export function time2Date(ts, n) {
  if (Number.isNaN(ts))
    return ts

  const t = (`${ts}`).split(':')
  const a
  = 1 * t[0] < 10 ** 11 && !t[1]
    ? new Date(1e3 * t[0])
    : new Date(1 * t[0])
  const
    i = a.getFullYear()
  const o = addZero(a.getMonth() + 1)
  const r = addZero(a.getDate())
  const c = addZero(a.getHours())
  const s = addZero(a.getMinutes())
  const u = addZero(a.getSeconds())
  return n
    ? n
        .toLowerCase()
        .replace('y', i)
        .replace('m', o)
        .replace('d', r)
        .replace('h', c)
        .replace('i', s)
        .replace('s', u)
    : `${i}-${o}-${r} ${c}:${s}:${u}`
}

export function getTimeLeft(ts, { hasDay = false } = {}) {
  ts = Math.floor(ts / 1000) * 1000
  const d = Math.floor(ts / 86400000)
  const h = addZero(Math.floor(ts % 86400000 / 3600000))
  const i = addZero(Math.floor(ts % 3600000 / 60000))
  const s = addZero(Math.floor(ts % 60000 / 1000))
  return hasDay ? [d, h, i, s] : [h, i, s]
}

export function countDown(ts, { hasDay = false } = {}) {
  ts = Math.floor(ts) * 1000
  const d = Math.floor(ts / 86400000)
  const h = addZero(Math.floor(ts % 86400000 / 3600000))
  const i = addZero(Math.floor(ts % 3600000 / 60000))
  const s = addZero(Math.floor(ts % 60000 / 1000))
  return hasDay ? [d, h, i, s] : [h, i, s]
}

export const onlyAllowNumber = (value, dp = 0, sign = false) => !value || new RegExp(dp > 0 ? `^${sign ? '-?' : ''}\\d*(\\.\\d{0,${dp}})?$` : `^${sign ? '-?' : ''}\\d*$`).test(value)

export function unzip(b64Data) {
  const strData = atob(b64Data)
  // Convert binary string to character-number array
  const charData = strData.split('').map((x) => {
    return x.charCodeAt(0)
  })
  // Turn number array into byte-array
  const binData = new Uint8Array(charData)
  // unzip
  return pako.inflate(binData, { to: 'string' })
}

export function convertImg({ type = 'jpeg', name = Date.now(), file }) {
  name = `${name}.${type}`
  type = `image/${type}`
  return new Promise((resolve) => {
    const reader = new FileReader()
    reader.onload = () => {
      const img = new Image()
      img.onload = () => {
        const canvas = document.createElement('canvas')
        const ctx = canvas.getContext('2d')
        canvas.width = img.width
        canvas.height = img.height
        ctx.drawImage(img, 0, 0)
        const base64 = canvas.toDataURL(type)
        const arr = base64.split(',')
        const mime = arr[0].match(/:(.*?);/)[1]
        const bytes = atob(arr[1])
        const bytesLength = bytes.length
        const u8arr = new Uint8Array(bytesLength)
        for (let i = 0; i < bytes.length; i++) {
          u8arr[i] = bytes.charCodeAt(i)
        }
        const blob = new Blob([u8arr], { type: mime })
        resolve({ file: new File([blob], name, { type }), base64, width: img.width, height: img.height })
      }
      img.src = reader.result
    }
    reader.readAsDataURL(file)
  })
}

export function volFilter(val, fixValue, roundMode) {
  if (Number.isNaN(+val)) {
    return val
  }
  let num = ''
  if (val) {
    let bigNum = new Decimal(val)
    Decimal.config({ EXPONENTIAL_AT: [-30, 30] })
    if (bigNum <= 999) {
      bigNum = bigNum.toFixed(fixValue, 1)
      return bigNum
    }
    const unit = ['k', 'M', 'B']
    for (let index = 0; index < unit.length && bigNum > 999; index += 1) {
      bigNum = new Decimal(bigNum).div(1000).toFixed(roundMode || 2, 1)
      const element = unit[index]
      num = `${bigNum}${element}`
    }
    return num
  }
  return val
}

// 生成随机UUID
export function makeUUID() {
  const chars = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz'.split('')
  const radix = chars.length
  const uuid = []
  for (let i = 0; i < 32; i++) uuid[i] = chars[0 | Math.random() * radix]
  return uuid.join('')
}

export function getDeviceId() {
  const deviceId = useStorage('DEVICE-ID', CryptoJS.SHA256(`${window.navigator.userAgent} 1.0.0 ${+new Date()} ${~~(
    Math.random() * 100000
  )}`).toString()).value
  return deviceId
}

export function getTokenByUrl() {
  if (import.meta.client) {
    return new URLSearchParams(location.search).get('token')
  }
}

// 根据浏览器语言获取区号
export function getDialingCodeByLocale(locale) {
  if (import.meta.client) {
    locale ||= navigator.language?.split('-')[0]
    return dialingLocaleMap[locale] || defaultDialingCode
  }
  return defaultDialingCode
}

// 获取顶级域名
export function getTopDomainByUrl() {
  if (import.meta.client) {
    const { hostname } = location
    const o = hostname.split('.')
    return o.length < 2 ? hostname : `.${o.slice(-2).join('.')}`
  }

  return domain
}

// 获取合伙人后台链接
export function getPartnerDomain() {
  const mainDomain = getTopDomainByUrl()
  return `https://partner${mainDomain}/home`
}

// 设置合伙人token
export  function setPartnerToken(token) {
  const mainDomain = getTopDomainByUrl()
  cookie.set('partner-token', token, {
    domain: mainDomain,
    expires: 365,
  })
}